import invariant from 'invariant';
import React from 'react';
import { connect } from 'react-redux';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"react-router"' has no exported member 'Co... Remove this comment to see the full error message
import { ContextRouter, withRouter } from 'react-router';

import { CurrentUser } from 'api/currentUser';
import EmailSignupForm from 'components/EmailSignupForm';
import { updateCurrentUser } from 'store/main/ducks/currentUser';
import { showModal } from 'store/main/ducks/modal';
import { trackSignUp } from 'utils/analytics';
import configureTrackJs from 'utils/configureTrackJs';
import getThirdPartyLoginUrl from 'utils/getThirdPartyLoginUrl';
import { postJson } from 'utils/http';
import { resetRecaptcha } from 'utils/recaptcha';
import { saveTemporaryStorageAndGenerateRedirectURL } from 'utils/temporaryStorage';

type InitialProps = {
  isModal: boolean;
  redirectTo: string | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  savedListing: Record<string, any> | null | undefined;
  subscribedSubsite: string | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSignup?: (...args: Array<any>) => any;
  onLogin?: ((arg0: CurrentUser) => void) | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loginOverrideFn?: (...args: Array<any>) => any;
  compactView?: boolean;
  hideLoginBlock?: boolean;
};
type OwnProps = InitialProps & ContextRouter;
type Props = OwnProps & {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateCurrentUser: (...args: Array<any>) => any;
  showModal: typeof showModal;
};

class EmailSignupFormContainer extends React.PureComponent<Props> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line class-methods-use-this
  get initialValues() {
    return {
      email: '',
      recaptchaKey: 0,
      gRecaptchaResponse: undefined,
    };
  }

  showLoginModal = (email?: string, initialWarning?: string) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    this.props.showModal('LOGIN', {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      redirectTo: this.props.redirectTo,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      savedListing: this.props.savedListing,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      subscribedSubsite: this.props.subscribedSubsite,
      email,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      onLogin: this.props.onLogin,
      initialWarning,
    });
  };

  getLoginUrl = (email?: string) => {
    const { redirectTo, savedListing, subscribedSubsite } = this.props;
    return {
      pathname: '/login',
      state: {
        redirectTo,
        savedListing,
        subscribedSubsite,
        email,
      },
    };
  };

  getThirdPartyLoginUrl = (provider: 'facebook' | 'google') => {
    const { location, redirectTo, savedListing, subscribedSubsite } =
      this.props;
    return getThirdPartyLoginUrl({
      provider,
      redirectTo: redirectTo || `${location.pathname}${location.search}`,
      savedListing,
      subscribedSubsite,
    });
  };

  onSubmit = ({ values, handleError, updateSubmitting }) => {
    const { email, recaptchaKey, gRecaptchaResponse } = values;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    saveTemporaryStorageAndGenerateRedirectURL(this.props.redirectTo, {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      listing: this.props.savedListing,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      subscribedSubsiteId: this.props.subscribedSubsite,
    })
      .then((redirectTo) =>
        postJson('/data/website/signup-email', {
          email,
          gRecaptchaResponse,
          redirectTo,
        })
      )
      .then(({ user }) => {
        invariant(user.id, 'Missing user id');
        trackSignUp(user, 'Email');
        configureTrackJs(user.id);
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.updateCurrentUser(user);

        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        if (this.props.onSignup) {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          this.props.onSignup();
        }

        updateSubmitting(false);
      })
      .catch((error) => {
        const errorArray = error.responseJson && error.responseJson.errors;
        const emailInUseError =
          errorArray &&
          errorArray.find(
            (e) => e.name === 'email' && e.type === 'alreadyInUse'
          );

        if (emailInUseError) {
          this.showLoginModal(
            email,
            'An account with this email exists. Did you mean to login?'
          );
        } else {
          resetRecaptcha();
          handleError(error, {
            recaptchaKey: recaptchaKey + 1,
            gRecaptchaResponse: undefined,
          });
        }

        updateSubmitting(false);
      });
  };

  render() {
    return (
      <EmailSignupForm
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        isModal={this.props.isModal}
        initialValues={this.initialValues}
        showLoginModal={this.showLoginModal}
        getLoginUrl={this.getLoginUrl}
        getThirdPartyLoginUrl={this.getThirdPartyLoginUrl}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        loginOverrideFn={this.props.loginOverrideFn}
        onSubmit={this.onSubmit}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        compactView={this.props.compactView}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        hideLoginBlock={this.props.hideLoginBlock}
      />
    );
  }
}

// @ts-expect-error ts-migrate(2558) FIXME: Expected 2 type arguments, but got 1.
export default withRouter<InitialProps>(
  // @ts-expect-error ts-migrate(2558) FIXME: Expected 5 type arguments, but got 6.
  connect<Props, OwnProps, _, _, _, _>( // $FlowFixMe: react-redux complains about this type when wrapped in withRouter
    null, // $FlowFixMe: react-redux complains about this type when wrapped in withRouter
    {
      showModal,
      updateCurrentUser,
    }
  )(EmailSignupFormContainer)
);
